import types from "./types";
import store from "../store/configure.js";
import moment from "moment";
import connection from "../api/config/connection";
import scrollTo from "../utils/scrollTo";

const request = () => ({
  type: types.REQUEST_STOPINFO,
});
const received = (data, values, url) => ({
  type: types.RECEIVED_STOPINFO,
  data,
  values,
  url,
  dataTimestamp: moment().format(),
});
const failed = () => ({
  type: types.REQUEST_STOPINFO_FAILED,
});

let refreshTimeoutDelay = 25000;
let refreshTimeout = null;
const scheduleRefreshTimeout = () => {
  refreshTimeout = setTimeout(refreshTimeoutCallback, refreshTimeoutDelay);
};
const refreshTimeoutCallback = () => {
  requestAnimationFrame(() => {
    store.dispatch(refresh());
  });
};

const onClickRefresh = (callback) => {
  return (dispatch) => {
    requestAnimationFrame(() => {
      const isOnDemandCall = true;
      dispatch(refresh(isOnDemandCall, callback));
    });
  };
};

const refresh = (isOnDemandCall, callback) => {
  return (dispatch) => {
    dispatch({
      type: types.REFRESH_STOPINFO,
    });
    dispatch(request());
    const { url, values } = store.getState().stop || {};
    if (!url || !values) {
      dispatch(failed());
      scheduleRefreshTimeout();
      return;
    }
    const options = {
      method: "GET",
      url,
      params: Array.isArray(values) ? { stop: values.stop } : values,
    };
    connection
      .instance()(options)
      .then((response) => {
        const { data = {} } = response;
        const { results = [] } = data;
        if (!results.length) {
          dispatch(failed());
        } else {
          if (callback) callback(data.results[0]);
          dispatch(received(data.results[0], values, url, true));
          if (isOnDemandCall) {
            const resultsElement = document.querySelector(
              ".js-react-halte-header"
            );
            if (resultsElement) scrollTo.scrollToElement(resultsElement, -40);
          }
        }
        clearTimeout(refreshTimeout);
        scheduleRefreshTimeout();
      })
      .catch((xhr) => {
        dispatch(failed());
        scheduleRefreshTimeout();
      });
  };
};

const startRefreshInterval = (delayInMilliseconds = 25000, restart = true) => {
  refreshTimeoutDelay = delayInMilliseconds;
  return (dispatch) => {
    if (!restart && refreshTimeout) return;

    if (restart) dispatch(abortRefreshInterval());

    scheduleRefreshTimeout();

    dispatch({
      type: types.START_REFRESH_INTERVAL_STOPINFO,
    });
  };
};

const abortRefreshInterval = () => {
  if (refreshTimeout) {
    clearTimeout(refreshTimeout);
    refreshTimeout = null;
  }

  return (dispatch) => {
    dispatch({
      type: types.ABORT_REFRESH_INTERVAL_STOPINFO,
    });
  };
};

const setRequestValues = (values, url) => {
  return (dispatch) =>
    dispatch({
      type: types.SET_REQUEST_VALUES,
      values: values,
      url: url,
    });
};

export default {
  request,
  failed,
  received,
  refresh,
  startRefreshInterval,
  abortRefreshInterval,
  onClickRefresh,
  setRequestValues,
};



// WEBPACK FOOTER //
// ./src/actions/stop.js